import { render, staticRenderFns } from "./PrfCustomerTemplatePti.vue?vue&type=template&id=9f321490&scoped=true"
import script from "./PrfCustomerTemplatePti.vue?vue&type=script&lang=js"
export * from "./PrfCustomerTemplatePti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f321490",
  null
  
)

export default component.exports